import API_URL, { GOOGLE_MAPS_KEY } from '@/config';
import { formatPrice } from '@/lib/utils';
import { Box } from '@mui/material';
import { GoogleMap, Marker, useJsApiLoader, InfoWindow } from "@react-google-maps/api";
import React, { useEffect, useRef, useState } from 'react'

const containerStyle = {
    width: "100%",
    height: "400px",
};

const center = {
    lat: 28.6139, // Default center (Delhi)
    lng: 77.2090,
};


const MapView = ({ properties }: any) => {
    const [selectedProperty, setSelectedProperty] = useState<any>(null);
    const { isLoaded } = useJsApiLoader({
        id: "google-map-script",
        googleMapsApiKey: GOOGLE_MAPS_KEY, // 🔑
    });
    const mapRef = useRef(null);

    const onLoad = (map: any) => {
        mapRef.current = map;
        // Fit map to show all markers
        const bounds = new window.google.maps.LatLngBounds();
        properties.forEach((p: any) => {
            const lng = Number(p?.location?.coordinates[0]);
            const lat = Number(p?.location?.coordinates[1]);

            if (!isNaN(lat) && !isNaN(lng)) {
                bounds.extend({ lat, lng });
            }
        });

        map.fitBounds(bounds);
    };




    useEffect(() => {
        if (!mapRef.current || !properties.length) return;

        const bounds = new window.google.maps.LatLngBounds();
        properties.forEach((p: any) => {
            const lng = Number(p?.location?.coordinates?.[0]);
            const lat = Number(p?.location?.coordinates?.[1]);
            if (!isNaN(lat) && !isNaN(lng)) {
                bounds.extend({ lat, lng });
            }
        });

        if (!bounds.isEmpty()) {
            (mapRef.current as google.maps.Map).fitBounds(bounds);
        }
    }, [properties]);



    return (
        <Box className="border rounded-lg mb-2">
            {isLoaded && <GoogleMap
                mapContainerStyle={containerStyle}
                center={center}
                zoom={12}
                onLoad={onLoad}
            >
                {properties.map((property: any) => {
                    const lng = Number(property?.location?.coordinates?.[0]);
                    const lat = Number(property?.location?.coordinates?.[1]);
                    if (isNaN(lat) || isNaN(lng)) return null;

                    return (
                        <Marker
                            key={property._id}
                            position={{ lat, lng }}
                            // title={property.title}
                            onClick={() => setSelectedProperty(property)}
                        />
                    );
                })}

                {selectedProperty && (
                    <InfoWindow
                        position={{
                            lng: Number(selectedProperty?.location?.coordinates?.[0]),
                            lat: Number(selectedProperty?.location?.coordinates?.[1]),
                        }}
                        onCloseClick={() => setSelectedProperty(null)}
                    >
                        <Box sx={{ maxWidth: 200 }}>
                            <img
                                src={`${API_URL}/getImage/image/${selectedProperty.images[0]}` || "https://via.placeholder.com/150"}
                                alt={selectedProperty.title}
                                style={{ width: "100%", borderRadius: 8, marginBottom: 8 }}
                            />
                            <h3 style={{ margin: "4px 0" }} className="text-lg font-semibold">{selectedProperty.title}</h3>
                            <p style={{ margin: "4px 0", fontSize: "14px", color: "#ff0e0e" }} className="font-semibold">
                                {selectedProperty.price ? formatPrice(selectedProperty.price) : "No Price"}
                            </p>
                        </Box>
                    </InfoWindow>
                )}
            </GoogleMap>}
        </Box>
    )
}

export default MapView